import { useState, useEffect } from 'react';
import { withWindow } from '@shared/utils/withWindow';

/**
 * Hook that rotates through a list of placeholder strings.
 * Pauses rotation when the document is hidden (tab not active).
 */
export const useRotatingText = (placeholders: ReadonlyArray<string>): string => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (placeholders.length <= 1) {
      return;
    }

    const intervalId = withWindow(
      global =>
        global.setInterval(() => {
          if (!global.document.hidden) {
            setCurrentIndex(prevIndex => (prevIndex + 1) % placeholders.length);
          }
        }, 3000),
      undefined,
    );

    return () => {
      withWindow(global => {
        if (intervalId !== undefined) {
          global.clearInterval(intervalId);
        }
      });
    };
  }, [placeholders.length]);

  return placeholders[currentIndex] ?? placeholders[0] ?? '';
};
